import { createSlice } from "@reduxjs/toolkit";
import { docuSignbyBuyer, docuSignCallback, docusignRefresh } from "../../../thunks/buyer-thunks/BuyerThunks";
import { downloadIOWithSign } from "../../../thunks/common-thunks/commonThunk";

const initialState = {
    isDocuSignLoading : false,
    docuSignUrlDetails:null,
    signedStatus :null,
    ioSignedPDF : null,
    error : null,

}
export const docuSign = createSlice({
 name : "docuSign",
 initialState,
 reducers:{},
 extraReducers:(builder) =>{

    // Docusign initiation
    builder 
      .addCase(docuSignbyBuyer.pending, (state) =>{
          state.isDocuSignLoading = true;
      })
      .addCase(docuSignbyBuyer.fulfilled, (state,action) =>{
          state.isDocuSignLoading = false;
          state.docuSignUrlDetails = action.payload;
      })
      .addCase(docuSignbyBuyer.rejected, (state,action) =>{
          state.isDocuSignLoading = false;
      })
 

    //  Docusign completion
     builder
        .addCase(docuSignCallback.pending , (state) =>{
            state.isDocuSignLoading = true;
        })
        .addCase(docuSignCallback.fulfilled, (state,action) =>{
            state.isDocuSignLoading = false;
        })
        .addCase(docuSignCallback.rejected, (state,action) =>{
            state.isDocuSignLoading = false;
        })

    //  Insertion Order with buyer sign
     builder
        .addCase(downloadIOWithSign.pending , (state) =>{
            state.isDocuSignLoading = true;
        })
        .addCase(downloadIOWithSign.fulfilled, (state,action) =>{
            state.isDocuSignLoading = false;
            state.ioSignedPDF = action.payload;
        })
        .addCase(downloadIOWithSign.rejected, (state,action) =>{
            state.isDocuSignLoading = false;
        })
    
        // Refresh to fecth docusign success status immediately
        builder
         .addCase(docusignRefresh.pending , (state) =>{
            state.isDocuSignLoading = true;
        })
        .addCase(docusignRefresh.fulfilled, (state,action) =>{
            state.isDocuSignLoading = false;
            state.signedStatus = action.payload;
        })
        .addCase(docusignRefresh.rejected, (state,action) =>{
            state.isDocuSignLoading = false;
            state.signedStatus = action.payload;
        })
    }
 
})

export default docuSign.reducer;